import React, { useEffect } from 'react'
import Container from '../../../../Components/Container'
import './index.scss'
import VisualizationCard from './children/VisualizationCard'
import { Row } from 'react-bootstrap';
import { DASHBOARD_TABS } from '../../../../../config/tabConstants'
import { getDataFromUrlToken } from '../../../../utils/urlDataStore'
import { ResourceLoader } from '../../../../Components/ResourceLoader'
import { EmptyState } from '../../../../Packages/EmptyState'
import { FEEDBACK_360_SURVEY } from '../../../../../config/questionTypeConstants';
import { MAPPING_ORDER } from './constants';
import ArcteryxVisualizationCard from './children/ArcteryxVisualizationCard';

export default function MatrixVisualization(props) {
    useEffect(() => {
        if (!props.fetchMatrixVisualizationApi.isDataFetched && !props.isForPdfGeneration) {
            let currentProjectData = getDataFromUrlToken('projectDetails');
            props.fetchFeedback360MatrixVisualizationData({ projectId: currentProjectData.projectId, currentTab: DASHBOARD_TABS.TWO_BY_TWO_MATRIX, projectType: props.surveyDetailsApi.surveyDetails.projectType })
        }
    }, []);

    const matrixClass = props.isForPdfGeneration ? 'matrixvisualization-block-no-margin' : 'matrixvisualization-block';
    const currentProjectType = props.isForPdfGeneration ? props.projectType : props.surveyDetailsApi.surveyDetails.projectType

    return (
        <main className='main-wrapper'>
            <div className={matrixClass}>
                <Container> 
                    {
                        props.fetchMatrixVisualizationApi.isProcessing ? <ResourceLoader /> :
                            props.fetchMatrixVisualizationApi.error ? <EmptyState emptyStateMessage="No data found" /> :
                                <Row>
                                    {props.fetchMatrixVisualizationApi.data && MAPPING_ORDER.map((currentKey) =>
                                        currentProjectType === FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX ? <ArcteryxVisualizationCard currentData={props.fetchMatrixVisualizationApi.data[currentKey]} currentKey={currentKey} projectType={currentProjectType} /> : <VisualizationCard currentData={props.fetchMatrixVisualizationApi.data[currentKey]} currentKey={currentKey} projectType={currentProjectType} />
                                    )}
                                </Row>
                    }
                </Container>

            </div>
        </main>
    )
}
